import React, { PropsWithChildren } from "react";
import { CSSTransition } from "react-transition-group";
import { AppDimmer } from "./AppDimmer";
import { AppOverlay } from "./AppOverlay";
import { IsDefined } from "./IsDefined";

interface Props {
  primaryHeader?: string;
  secondaryHeader?: string;
  isOpen?: boolean;
}

const AppLoadingPlaceholder = (props: PropsWithChildren<Props>) => {
  return (
    <CSSTransition
      in={props.isOpen}
      timeout={250}
      classNames="AppLoadingPlaceholder"
      unmountOnExit={true}
    >
      <AppOverlay>
        <div className="AppLoadingPlaceholder">
          <div className="AppLoadingPlaceholder__SvgWrapper">
            <div className="AppLoadingPlaceholder__SvgCircle">
              <svg viewBox="25 25 50 50">
                <circle
                  fill="transparent"
                  stroke="rgba(255,255,255,0.2)"
                  className="still"
                  cx="50"
                  cy="50"
                  r="20"
                  strokeWidth="0.5"
                />
                <circle
                  fill="transparent"
                  stroke="#FFF"
                  className="animated"
                  cx="50"
                  cy="50"
                  r="20"
                  strokeWidth="0.7"
                />
              </svg>
            </div>
            <div className="AppLoadingPlaceholder__Headlines">
              <IsDefined value={props.primaryHeader}>
                {(primaryHeader) => <h3>{primaryHeader}</h3>}
              </IsDefined>
              <IsDefined value={props.secondaryHeader}>
                {(secondaryHeader) => <span>{secondaryHeader}</span>}
              </IsDefined>
            </div>
          </div>
          <AppDimmer />
        </div>
      </AppOverlay>
    </CSSTransition>
  );
};

export default React.memo(AppLoadingPlaceholder);
